export function DataTableEmptyRow() {
  return (
    <tr className="mantine-datatable-empty-row">
      <td />
    </tr>
  );
}
